// (c) 2026 Owl Consultations. All rights reserved.
// Proprietary and confidential — licensed use only. Unauthorized use,
// copying, or distribution is prohibited and may be prosecuted.

// D-RBAC-1 G-1 — "Users and groups" (Patrick 2026-09-11: "the groups need to be in Users & roles but
// rename it to Users and groups"). One pharmacy-side page, two tabs, both gated on admin.users.read
// by the route. The tab lives in the URL (?tab=groups) so links and the back button work; the two
// panels are the same components the admin console mounts at /admin/users and /admin/groups.
import { useSearchParams } from 'react-router-dom'
import { Layers, Users } from 'lucide-react'
import UsersTab from './admin/UsersTab'
import GroupsTab from './admin/GroupsTab'

type Tab = 'users' | 'groups'

export default function UsersAndGroupsPage() {
  const [params, setParams] = useSearchParams()
  const tab: Tab = params.get('tab') === 'groups' ? 'groups' : 'users'
  const go = (t: Tab) => setParams(t === 'users' ? {} : { tab: t }, { replace: true })

  return (
    <div>
      <div role="tablist" aria-label="Users and groups" style={strip}>
        <button role="tab" aria-selected={tab === 'users'} onClick={() => go('users')} style={tab === 'users' ? active : btn}>
          <Users size={14} aria-hidden="true" /> Users
        </button>
        <button role="tab" aria-selected={tab === 'groups'} onClick={() => go('groups')} style={tab === 'groups' ? active : btn}>
          <Layers size={14} aria-hidden="true" /> Groups
        </button>
      </div>
      {tab === 'users' ? <UsersTab /> : <GroupsTab />}
    </div>
  )
}

const strip: React.CSSProperties = {
  display: 'flex', gap: 4, padding: '8px 1.25rem 0', borderBottom: '1px solid var(--color-border, #e5e7eb)',
}
const btn: React.CSSProperties = {
  display: 'inline-flex', alignItems: 'center', gap: 6, padding: '8px 12px', fontSize: 13, fontWeight: 500,
  background: 'transparent', border: 'none', borderBottom: '2px solid transparent', marginBottom: -1,
  color: 'var(--color-text-soft, #6b7280)', cursor: 'pointer',
}
const active: React.CSSProperties = {
  ...btn, color: 'var(--color-primary, #185FA5)', borderBottomColor: 'var(--color-primary, #185FA5)',
}
